import { Layout } from 'containers/';
import {
  getPropertyDetail,
  getPropertyDetailImage,
  getPropertyDetailLocation,
} from '@services/property-shares';
import { Property } from 'components/';
import NotFound from 'components/NotFound';
const BASE_URL = process.env.API;

export async function getServerSideProps(context) {
  try {
    const getProperty = await getPropertyDetail(context.params.slug);

    const getImage = await getPropertyDetailImage(
      getProperty?.data?.property?.links?.property_images,
    );
    const getLocation = await getPropertyDetailLocation(
      getProperty?.data?.property?.links?.property_locations,
    );
    getImage.data.map(async (obj) => {
      if (obj.is_360) {
        obj.image.cors = `${BASE_URL}/service/proxy-images?url=${obj?.image?.url}`;
      }
    });
    return {
      props: {
        data: getProperty?.data || [],
        images: getImage?.data,
        location: getLocation?.data.find((val) => val.is_publish),
      },
    };
  } catch (error) {
    return {
      props: {
        data: [],
      },
    };
  }
}

const PropertyPage = ({ data, images, location }) => {
  if (data.length === 0) {
    return <NotFound />;
  }

  return (
    <Layout title="Listing Property Detail | One21">
      <Property data={data} images={images} location={location} />
    </Layout>
  );
};

export default PropertyPage;
